// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select {
  width: 200px;
  margin-top: 1px;
  margin-left: 10px;
}

.changeDetailSelect {
  display: flex inline;
  margin-left: 10px;
  margin-top: 20px;
}

.leftPane-checkbox {
  margin-left: 10px;
}

.leftPane-label {
  margin-left: 10px;
  font-weight: bold;
}

.warn {
  width: 200px;
  margin-left: 10px;
  padding-top: 0px;
  margin-bottom: 10px;
  font-size: 11px;
  color: #e30526;
}

:host ::ng-deep .p-multiselect-panel {
  width: 200px;
}

:host ::ng-deep .p-select {
  width: 200px;
}

.button {
  margin-left: 20px;
  margin-top: 10px;
  width: 175px;
  text-align: center;
}

.mat-icon {
  margin-bottom: 5px;
}

#custom-sidenav-container {
  display: inherit;
  transform: inherit;
  position: static;
  height: 100%;
  overflow: visible;
}

.cplFooter {
  bottom: 0px;
}

.menu-relative {
  display: flex;
  width: 100%;
  overflow-y: inherit;
}

.label {
  margin-top: 10px;
  margin-left: 10px;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 17px;
}

.select {
  width: 200px;
  margin-top: 20px;
  margin-left: 10px;
  padding-bottom: 5px;
}

.table {
  margin: 10px;
}

.table-header {
  font-weight: bold;
  background-color: #f2f2ef;
  color: #3b3b39;
  font-size: 15pt;
  text-align: center;
  margin-top: 2px;
  margin-bottom: 2px;
  padding-bottom: 7px;
  padding-top: 5px;
}

.segment {
  font-weight: bold;
  background-color: #7b7b7b;
  color: #ffffff;
  margin-top: 5px;
  padding-left: 10px;
  padding-bottom: 5px;
  padding-top: 3px;
}

.region {
  font-weight: bold;
  margin-top: 3px;
  padding-left: 15px;
  border-bottom: 1px solid black;
  padding-bottom: 4px;
}

.menu-relative {
  display: flex;
  width: 100%;
}

.header-style {
  font-weight: bold;
  font-size: 15px;
  width: 60px !important;
  text-align: left;
  padding-left: 5px !important;
  padding-right: 5px !important;
}

tr.mat-mdc-header-row {
  height: 20px !important;
  padding-top: 3px !important;
}

.table-div {
  width: 100%;
  padding-bottom: 20px;
  overflow: hidden;
}

.mat-mdc-row,
.mat-mdc-header-row {
  height: 35px;
  white-space: nowrap;
}

.mat-mdc-table-div {
  max-height: 85vh;
}

.check-mark {
  padding-left: 7px;
}

.message {
  background-color: yellow;
  border: 1px solid black;
  padding: 3px;
  margin-bottom: 9px;
  border-radius: 5px;
  font-weight: bold;
}

.center-year-col {
  text-align: center;
  width: 100%;
}

.tableCell {
  border: 1px solid #d7d7d7;
}

.smallIcon {
  font-size: 12px;
  margin-bottom: 0;
  height: 12px;
  width: 12px;
}

table {
  margin-top: 10px;
  width: 100%;
}

.styledTable {
  margin-bottom: 50px;
  border-collapse: collapse;
  position: relative;
}

.segStyle {
  padding-left: 5px;
  color: rgba(0, 0, 0, 0.5411764706);
}

.table-relative {
  width: 100%;
  margin-bottom: 20px;
}

.mat-mdc-cell {
  width: 25px;
  word-break: break-all;
  border-right: 1px solid #d7d7d7;
  padding-left: 5px !important;
  padding-right: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 13px;
  text-align: center;
  border-right: 1px solid #d7d7d7;
}

tr.mat-mdc-header-row {
  height: 20px !important;
  padding-top: 3px !important;
}

tr.mat-mdc-row {
  height: 28px;
}

td,
td {
  text-align: center;
  width: 15px;
  word-break: break-word;
}

/*(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/
mat-tab-group {
  width: 100%;
}

.mat-drawer {
  top: auto;
  bottom: auto;
}

::ng-deep #fabOptionSelect-panel .cdk-virtual-scroll-content-wrapper {
  width: inherit;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/reports/competitive-activity-landscape/competitive-activity-landscape.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AACF;;AACA;EACE,oBAAA;EACA,iBAAA;EACA,gBAAA;AAEF;;AACA;EACE,iBAAA;AAEF;;AACA;EACE,iBAAA;EACA,iBAAA;AAEF;;AACA;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAEF;;AACA;EACE,YAAA;AAEF;;AAAA;EACE,YAAA;AAGF;;AAAA;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAGF;;AAAA;EACE,kBAAA;AAGF;;AAAA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AAGF;;AAAA;EACE,WAAA;AAGF;;AADA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAIF;;AAFA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAKF;;AAFA;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAKF;;AAFA;EACE,YAAA;AAKF;;AAFA;EACE,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAKF;;AAFA;EACE,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAKF;;AAFA;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;AAKF;;AAFA;EACE,aAAA;EACA,WAAA;AAKF;;AAFA;EACE,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,4BAAA;EACA,6BAAA;AAKF;;AAFA;EACE,uBAAA;EACA,2BAAA;AAKF;;AAFA;EACE,WAAA;EACA,oBAAA;EACA,gBAAA;AAKF;;AAFA;;EAEE,YAAA;EACA,mBAAA;AAKF;;AAFA;EAEE,gBAAA;AAIF;;AADA;EACE,iBAAA;AAIF;;AADA;EACE,wBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAIF;;AADA;EACE,kBAAA;EACA,WAAA;AAIF;;AADA;EACE,yBAAA;AAIF;;AADA;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AAIF;;AAFA;EACE,gBAAA;EACA,WAAA;AAKF;;AAFA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;AAKF;;AAFA;EACE,iBAAA;EACA,kCAAA;AAKF;;AAFA;EACE,WAAA;EACA,mBAAA;AAKF;;AAFA;EACE,WAAA;EACA,qBAAA;EACA,+BAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,+BAAA;AAKF;;AAFA;EACE,uBAAA;EACA,2BAAA;AAKF;;AAFA;EACE,YAAA;AAKF;;AAFA;;EAEE,kBAAA;EACA,WAAA;EACA,sBAAA;AAKF;;AAFA,qHAAA;AACA;EACE,WAAA;AAKF;;AAFA;EACE,SAAA;EACA,YAAA;AAKF;;AAAE;EACE,cAAA;AAGJ;AACA,w/OAAw/O","sourcesContent":[".select {\n  width: 200px;\n  margin-top: 1px;\n  margin-left: 10px;\n}\n.changeDetailSelect {\n  display: flex inline;\n  margin-left: 10px;\n  margin-top: 20px;\n}\n\n.leftPane-checkbox {\n  margin-left: 10px;\n}\n\n.leftPane-label {\n  margin-left: 10px;\n  font-weight: bold;\n}\n\n.warn {\n  width: 200px;\n  margin-left: 10px;\n  padding-top: 0px;\n  margin-bottom: 10px;\n  font-size: 11px;\n  color: #e30526;\n}\n\n:host ::ng-deep .p-multiselect-panel {\n  width: 200px;\n}\n:host ::ng-deep .p-select {\n  width: 200px;\n}\n\n.button {\n  margin-left: 20px;\n  margin-top: 10px;\n  width: 175px;\n  text-align: center;\n}\n\n.mat-icon {\n  margin-bottom: 5px;\n}\n\n#custom-sidenav-container {\n  display: inherit;\n  transform: inherit;\n  position: static;\n  height: 100%;\n  overflow: visible;\n}\n\n.cplFooter {\n  bottom: 0px;\n}\n.menu-relative {\n  display: flex;\n  width: 100%;\n  overflow-y: inherit;\n}\n.label {\n  margin-top: 10px;\n  margin-left: 10px;\n  margin-bottom: 10px;\n  font-weight: bold;\n  font-size: 17px;\n}\n\n.select {\n  width: 200px;\n  margin-top: 20px;\n  margin-left: 10px;\n  padding-bottom: 5px;\n}\n\n.table {\n  margin: 10px;\n}\n\n.table-header {\n  font-weight: bold;\n  background-color: #f2f2ef;\n  color: #3b3b39;\n  font-size: 15pt;\n  text-align: center;\n  margin-top: 2px;\n  margin-bottom: 2px;\n  padding-bottom: 7px;\n  padding-top: 5px;\n}\n\n.segment {\n  font-weight: bold;\n  background-color: #7b7b7b;\n  color: #ffffff;\n  margin-top: 5px;\n  padding-left: 10px;\n  padding-bottom: 5px;\n  padding-top: 3px;\n}\n\n.region {\n  font-weight: bold;\n  margin-top: 3px;\n  padding-left: 15px;\n  border-bottom: 1px solid black;\n  padding-bottom: 4px;\n}\n\n.menu-relative {\n  display: flex;\n  width: 100%;\n}\n\n.header-style {\n  font-weight: bold;\n  font-size: 15px;\n  width: 60px !important;\n  text-align: left;\n  padding-left: 5px !important;\n  padding-right: 5px !important;\n}\n\ntr.mat-mdc-header-row {\n  height: 20px !important;\n  padding-top: 3px !important;\n}\n\n.table-div {\n  width: 100%;\n  padding-bottom: 20px;\n  overflow: hidden;\n}\n\n.mat-mdc-row,\n.mat-mdc-header-row {\n  height: 35px;\n  white-space: nowrap;\n}\n\n.mat-mdc-table-div {\n  //overflow: auto;\n  max-height: 85vh;\n}\n\n.check-mark {\n  padding-left: 7px;\n}\n\n.message {\n  background-color: yellow;\n  border: 1px solid black;\n  padding: 3px;\n  margin-bottom: 9px;\n  border-radius: 5px;\n  font-weight: bold;\n}\n\n.center-year-col {\n  text-align: center;\n  width: 100%;\n}\n\n.tableCell {\n  border: 1px solid #d7d7d7;\n}\n\n.smallIcon {\n  font-size: 12px;\n  margin-bottom: 0;\n  height: 12px;\n  width: 12px;\n}\ntable {\n  margin-top: 10px;\n  width: 100%;\n}\n\n.styledTable {\n  margin-bottom: 50px;\n  border-collapse: collapse;\n  position: relative;\n}\n\n.segStyle {\n  padding-left: 5px;\n  color: #0000008a;\n}\n\n.table-relative {\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.mat-mdc-cell {\n  width: 25px;\n  word-break: break-all;\n  border-right: 1px solid #d7d7d7;\n  padding-left: 5px !important;\n  padding-right: 5px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  font-size: 13px;\n  text-align: center;\n  border-right: 1px solid #d7d7d7;\n}\n\ntr.mat-mdc-header-row {\n  height: 20px !important;\n  padding-top: 3px !important;\n}\n\ntr.mat-mdc-row {\n  height: 28px;\n}\n\ntd,\ntd {\n  text-align: center;\n  width: 15px;\n  word-break: break-word;\n}\n\n/*(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/\nmat-tab-group {\n  width: 100%;\n}\n\n.mat-drawer {\n  top: auto;\n  bottom: auto;\n}\n\n::ng-deep #fabOptionSelect-panel {\n  //  overflow: auto!important;\n  .cdk-virtual-scroll-content-wrapper {\n    width: inherit;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
